import Axios from "axios";

const base_url = "cp/shipping-routes";

export default {
    /**
     * Display a listing of the ShippingRoutes.
     *
     * @param {int} page number of page for pagination
     * @param {object} params filter (search) options
     * @returns {Promise}
     */
    getAll(page = 1, params = {}) {
        return Axios.get(base_url + "?page=" + page, { params });
    },

    /**
     * Get all routes with specific properties of ShippingRoutes.
     *
     * @returns {Promise}
     */
    getAllShort() {
        return Axios.get(`${base_url}/short`);
    },

    /**
     * Store a new ShippingRoute in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    create(data) {
        return Axios.post(base_url, data);
    },

    /**
     * Update the given ShippingRoute in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    update(data) {
        return Axios.put(base_url + "/" + data.id, data);
    }
};
